import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-subscribtion-confirm',
    templateUrl: './subscribtionConfirm.component.html',
    styleUrls: ['./subscribtionConfirm.component.css']
})
export class SubscribtionConfirmComponent implements OnInit  {


    constructor() {
    }

    ngOnInit() {
        
    }

}
